
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/guidebooks",
      function () {
        return require("private-next-pages/resources/guidebooks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/guidebooks"])
      });
    }
  